import { OrdAllocateI } from '../../api/ord-allocate/ord-allocate.result.int';
import { OrdAllocateQueryI } from 'src/app/api/ord-allocate/ord-allocate.query.int';
import { createActionGroup } from '@ngrx/store';
import { spxCreateApiActions } from '@softpak/components/spx-redux';

export const OrdDeAllocateSingleActions = createActionGroup({
  source: 'OrdDeAllocateSingle',
  events: {
    ...spxCreateApiActions<OrdAllocateQueryI, OrdAllocateI>(),
  },
});